import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=25236057"
var script = {}
import style0 from "./Car.vue?vue&type=style&index=0&id=25236057&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports